export enum InputType {
    From = "from",
    To = "to",
    FederalStates = "federal_states",
    Tags = "tags"
}
